/**
 * One message's system notification (ADR 0106): its tag, and closing it.
 *
 * The push worker (public/push-sw.js) and the open app's own poll
 * (useNotificationPoller.ts) both raise a message's notice under
 * `ols-mail-<account id>:<message id>`, so either one closes it by the same
 * tag. It is closed when the message is opened here, and when the live stream
 * says another device read it (`\Seen` added) or it was expunged — so a notice
 * for mail already dealt with does not linger on this device.
 *
 * Only notices raised through the service worker can be found again
 * (`getNotifications`), which is every notice on Android and every push. A
 * desktop page's `new Notification()` is not listed there; the browser drops
 * those on its own.
 */
export function messageNoticeTag(accountId: string, messageId: string): string {
  return `ols-mail-${accountId}:${messageId}`;
}

export async function closeMessageNotices(
  accountId: string,
  messageIds: readonly string[],
): Promise<void> {
  if (accountId === "" || messageIds.length === 0) return;
  try {
    const registration = await navigator.serviceWorker?.getRegistration();
    if (
      registration === undefined ||
      typeof registration.getNotifications !== "function"
    )
      return;
    for (const id of messageIds) {
      const shown = await registration.getNotifications({
        tag: messageNoticeTag(accountId, id),
      });
      for (const notice of shown) notice.close();
    }
  } catch {
    /* No worker, no notices to close. */
  }
}
